module.exports = __webpack_public_path__ + "img/浅野陽平.a646d3ef.jpg";